// extracted by mini-css-extract-plugin
module.exports = {"container":"song-tempo_container___p9Fs","skeleton_animate":"song-tempo_skeleton_animate__LQ0HX"};